export const clearPhone = (phone: string) => phone.replace(/^\+|[^\d]/g, '');
